import parser from 'parse-address'
import { GREEN, ORANGE, RED } from '../../constants/indicators'
import { FALLBACK_APPRECIATION_PERCENT } from '../../constants/appreciation'

const LISTING_CAUTION_FACTOR = 1.1

export const getListingRecommendationStatus = (
  potentialSavings,
  listingMonthlyCost,
  maxBudget
) => {
  if (
    isNaN(potentialSavings) ||
    isNaN(listingMonthlyCost) ||
    isNaN(maxBudget)
  ) {
    return null
  }

  if (potentialSavings >= 0) {
    if (listingMonthlyCost <= maxBudget * LISTING_CAUTION_FACTOR) return GREEN
    else return ORANGE
  } else {
    if (listingMonthlyCost <= maxBudget * LISTING_CAUTION_FACTOR) return ORANGE
    else return RED
  }
}

export const getHomeownerListingRecommendationStatus = (
  totalBuyCost,
  listingMonthlyCost,
  maxBudget
) => {
  if (isNaN(totalBuyCost) || isNaN(listingMonthlyCost) || isNaN(maxBudget)) {
    return null
  }

  if (totalBuyCost < 0) {
    if (listingMonthlyCost <= maxBudget * LISTING_CAUTION_FACTOR) return GREEN
    else return ORANGE
  } else {
    if (listingMonthlyCost <= maxBudget * LISTING_CAUTION_FACTOR) return ORANGE
    else return RED
  }
}

export const getListingRecommendationDecorators = status => {
  switch (status) {
    case GREEN:
      return {
        color: GREEN,
        text: 'Smart',
        theme: 'success',
      }
    case ORANGE:
      return {
        color: ORANGE,
        text: 'Fair',
        theme: 'warning',
      }
    case RED:
      return {
        color: RED,
        text: 'Weak',
        theme: 'danger',
      }
    default:
      return {
        color: 'pink',
        text: '',
        theme: 'none',
      }
  }
}

export const getListingZipcode = address => {
  if (!address) {
    return null
  }

  const { zip } = parser.parseLocation(address)

  return zip
}

export const getListingStreet = address => {
  if (!address) {
    return null
  }

  const addressObject = parser.parseLocation(address)

  const { number, prefix, street, type, suffix } = addressObject

  const streetNumber = number || ''
  const streetPrefix = prefix || ''
  const streetName = street || ''
  const streetType = type || ''
  const streetSuffix = suffix || ''

  return `${streetNumber} ${streetPrefix} ${streetName} ${streetType} ${streetSuffix}`
    .replace(/\s+/g, ' ')
    .trim()
}

export const getCashPositionIndicator = (listingMonthlyCost, budget) => {
  if (!listingMonthlyCost || !budget) {
    return null
  }

  const indicator = {
    rentDiff: listingMonthlyCost - budget,
  }

  if (listingMonthlyCost <= budget) {
    return decorateIndicator(indicator, GREEN)
  } else if (
    listingMonthlyCost > budget &&
    listingMonthlyCost <= LISTING_CAUTION_FACTOR * budget
  ) {
    return decorateIndicator(indicator, ORANGE)
  }

  return decorateIndicator(indicator, RED)
}

export const getAppreciationIndicator = (
  annualAppreciationPercent,
  yearsOfData
) => {
  const appreciationPercent =
    yearsOfData === null || yearsOfData === 0
      ? FALLBACK_APPRECIATION_PERCENT
      : annualAppreciationPercent

  if (!appreciationPercent) {
    return null
  }

  const indicator = {
    appreciationPercent,
    yearsOfData,
  }

  if (appreciationPercent >= 5) {
    return decorateIndicator(indicator, GREEN)
  } else {
    return decorateIndicator(indicator, ORANGE)
  }
}

export const getMarketTempIndicator = marketTemp => {
  if (!marketTemp) {
    return null
  }

  const indicator = {
    marketTemp,
  }

  if (marketTemp >= 60) {
    return decorateIndicator(indicator, ORANGE)
  }

  return decorateIndicator(indicator, GREEN)
}

const decorateIndicator = (indicator, color) => {
  if (color === GREEN) {
    return {
      ...indicator,
      color,
      text: 'Smart',
      theme: 'success',
    }
  } else if (color === ORANGE) {
    return {
      ...indicator,
      color,
      text: 'Fair',
      theme: 'warning',
    }
  } else if (color === RED) {
    return {
      ...indicator,
      color,
      text: 'Weak',
      theme: 'danger',
    }
  } else {
    return {
      ...indicator,
      color: null,
      text: '',
      theme: 'none',
    }
  }
}
